import { Component, OnInit } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';


@Component({
  selector: 'app-for-business',
  templateUrl: './for-business.component.html',
  styleUrls: ['./for-business.component.scss'],
  standalone: false
})
export class ForBusinessComponent implements OnInit {
  Routes = ROUTES;
  activeSection = 'automotive';

  sections = [
    { id: 'automotive', label: 'Automotive OEM', icon: 'bx-car' },
    { id: 'fleet', label: 'Fleet & Logistics', icon: 'bx-trip' },
    { id: 'insurance', label: 'Insurance (BFSI)', icon: 'bx-shield-alt-2' },
    { id: 'enterprise', label: 'Enterprise', icon: 'bx-buildings' },
  ];

  microsites = [
    { title: 'Automotive OEM', subtitle: 'Connected OEM digital platform', icon: 'bx-car', route: '/solutions/business/automotive-oem' },
    { title: 'Fleet & Logistics', subtitle: 'Fleet management & tracking', icon: 'bx-transfer', route: '/solutions/business/fleet-logistics' },
    { title: 'Insurance (BFSI)', subtitle: 'Telematics for insurers', icon: 'bx-shield-quarter', route: '/solutions/business/insurance' },
    { title: 'Enterprise', subtitle: 'Enterprise-grade solutions', icon: 'bx-building', route: '/solutions/business/enterprise' },
  ];

  ngOnInit() {}


  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.activeSection = sectionId;
  }

  private setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.activeSection = entry.target.id;
        });
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );
    this.sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
  }
}
